import { UserDetailsAccreditation } from "./UserDetailsAccreditation";

export class UserDetailsResponse {
     id: string;
     name: string;
     driveUser: boolean;
     userAccreditations: UserDetailsAccreditation[];
}